/**
 * Global list of keys that are used by the caching.
 *
 * Right now it is unused because the caching has only been implemented for the end-user and it
 * cannot be used there.
 */
export var CacheKeys;
(function (CacheKeys) {
})(CacheKeys || (CacheKeys = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGUta2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2xpYi9jYWNoZS1rZXlzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFOLElBQVksU0FBWTtBQUF4QixXQUFZLFNBQVM7QUFBRSxDQUFDLEVBQVosU0FBUyxLQUFULFNBQVMsUUFBRyJ9